import React, { useState, useRef } from 'react';
import Form from '../../Modules/form/components/Form'; // We will use the form's onSubmit for both buttons
import { Card, CardBody, FormGroup, Label, Row, Col, Button} from 'reactstrap';
import Box from '@material-ui/core/Box';
import { exportDataRequest } from  './hooks';
import LoadingButton from '../Helpers/LoadingButton';
import SendFranchisePartnerAccountingExportButton from '../../Modules/buttons/components/specialized/SendFranchisePartnerAccountingExportButton';
import { useApi } from '../../Modules/api/components/ApiProvider';
import { EXPORT_RESOURCE } from '../../Modules/api/resources';
import { useSnackbar } from '../../Modules/snackbar/hooks';
import ProvisionMonthSelect from '../../Modules/form/components/specialized/ProvisionMonthSelect';
import DateInput from '../../Modules/form/components/DateInput';
import LocationSelect from '../../Modules/form/components/specialized/LocationSelect';

const EXPORT_TYPE = 'franchise_partner_accounting_excel';
const FORM_KEY = 'franchise_partner_accounting_export';

const FranchisePartnerAccountingExport_Excel = () => {
    const [loading, setLoading] = useState(false);
    const submitter = useRef(null); // Ref to track which button was clicked

    const api = useApi();
    const { enqueueSnackbar } = useSnackbar();

    const sendFranchisePartnerAccountingExport = (values) => {
        console.log('onClickSendFranchisePartnerAccountingExport values:', values);

        if (!values.location) {
            enqueueSnackbar('Bitte einen Standort auswählen!', { variant: 'error' });
            return;
        }
        if ((!values.date_from || !values.date_till) && !values.provision_month) {
            enqueueSnackbar('Bitte einen Zeitraum oder Monat auswählen!', { variant: 'error' });
            return;
        }

        const preppedValues = {
            type: EXPORT_TYPE,
            date_from: values.date_from,
            date_till: values.date_till,
            provision_month: values.provision_month,
            location: values.location,
        };

        api[EXPORT_RESOURCE].addQueuedJobSendExportToRecipient(preppedValues).then((result) => {
            enqueueSnackbar('Erfolgreich: Franchisepartnerabrechnungen werden exportiert und an die Standard-Empfänger gesendet!', { variant: 'success' });
        })
    };


    const handleExportSubmit = async (values) => {
        // Check which button was clicked
        if (submitter.current === 'send_export') {
            sendFranchisePartnerAccountingExport(values);
            return; // Stop further execution
        }

        // This is the 'Herunterladen' (Download) logic

        if (values.date_from && values.date_till) {
            const fromDate = new Date(values.date_from);
            const tillDate = new Date(values.date_till);
            if (isNaN(fromDate) || isNaN(tillDate)) {
                enqueueSnackbar('Ungültiges Datum im Zeitraum!', { variant: 'error' });
                return false;
            }
            if (fromDate > tillDate) {
                enqueueSnackbar('Das Startdatum darf nicht nach dem Enddatum liegen!', { variant: 'error' });
                return false;
            }
        }
        else if (values.provision_month)
        {
            const monthDate = new Date(values.provision_month);
            if (isNaN(monthDate)) {
                enqueueSnackbar('Ungültiger Monat!', { variant: 'error' });
                return false;
            }
        }
        else {
            enqueueSnackbar('Bitte einen Zeitraum oder Monat auswählen!', { variant: 'error' });
            return false;
        }

        try {
            setLoading(true);
            await exportDataRequest(EXPORT_TYPE, values);
        } catch (err) {
            enqueueSnackbar(`Fehler beim Export: ${err.message}`, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };


    return  (
        <Box mt={3}>
            <Card data-cy="card-franchisepartneraccountingexport">
                <h6 className="card-header">Franchisepartnerabrechnungen-Excel-Datei</h6>
                <CardBody>
                    <p>
                        Unter folgendem Link kann die Datei für die Franchisepartnerabrechnungen heruntergeladen
                        werden.
                    </p>
                    <Form
                        onSubmit={handleExportSubmit}
                    >
                        <Row>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="Zeitraum vom:"
                                        name="date_from"
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="bis:"
                                        name="date_till"
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="text-center">
                                <br />
                                oder Monat
                            </Col>
                            <Col>
                                <ProvisionMonthSelect
                                    name="provision_month"
                                    fullWidth
                                    label="Monat"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Standort:</Label>
                                    <LocationSelect
                                        name="location"
                                        label="Standort"
                                        fullWidth
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-center">
                                <LoadingButton
                                    color="primary"
                                    id={FORM_KEY}
                                    title="Klicken um die Datei herunterzuladen"
                                    type="submit"
                                    isLoading={loading}
                                    name="download_export"
                                    onClick={() => { submitter.current = 'download_export'; }}
                                >
                                    Herunterladen
                                </LoadingButton>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col>
                                <div className="text-center">
                                <SendFranchisePartnerAccountingExportButton
                                    type ="submit"
                                    name="contact_list"
                                    onClick={() => { submitter.current = 'send_export'; }}
                                >
                                    Export per E-Mail senden
                                </SendFranchisePartnerAccountingExportButton>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col>
                                <Button type="reset" color="secondary" className="ml-2">
                                    Zurücksetzen
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </Box>
    )
};

FranchisePartnerAccountingExport_Excel.propTypes = {
};

FranchisePartnerAccountingExport_Excel.defaultProps = {
};
export default FranchisePartnerAccountingExport_Excel;
